/** Labels and styling for artefact approve / not-approve decisions. */

import type { ArtefactApprovalDecision } from "./types";

export function approvalDecisionLabel(decision: ArtefactApprovalDecision): string {
  return decision === "approve" ? "Approve" : "Do not approve";
}

export function approvalDecisionShortLabel(decision: ArtefactApprovalDecision): string {
  return decision === "approve" ? "Approved" : "Not approved";
}

export function approvalDecisionClasses(decision: ArtefactApprovalDecision): {
  text: string;
  ring: string;
  bg: string;
} {
  if (decision === "approve") {
    return {
      text: "text-emerald-300",
      ring: "ring-emerald-500/30",
      bg: "bg-emerald-500/10",
    };
  }
  return {
    text: "text-rose-300",
    ring: "ring-rose-500/30",
    bg: "bg-rose-500/10",
  };
}
